import PropTypes from "prop-types";
import React from "react";

import { getSectionSlugBySectionId } from "../../../../../lib/getSectionSlugBySectionId";
import { getNewBadgeIfIsNew } from "../../../../../lib/stockAiAnalysis/getNewBadge";
import withTranslations from "../../../../../hocs/withTranslations";
import { AUTOMATIC_STRATEGY_PERMISSIONS } from "../../../../../redux/modules/auth/userPermissions/selector";
import AutomaticTransactionSignal from "../../AutomaticTransactionSignal";
import StockPageSection from "../../StockPageSection";

const TransactionSignalSections = ({
  strategies,
  preparedSlugList,
  ticker,
  market,
  stockName,
  shortName,
  translate,
  filterMarket
}) => {
  return (
    <React.Fragment>
      {strategies.map(strategy => (
        <StockPageSection
          ticker={ticker}
          market={market}
          key={strategy.id}
          title={strategy.name}
          sectionId={strategy.notifications_unique_id}
          sectionPermissions={
            AUTOMATIC_STRATEGY_PERMISSIONS[strategy.notifications_unique_id] ||
            []
          }
          slug={getSectionSlugBySectionId(
            preparedSlugList,
            strategy.notifications_unique_id
          )}
          label={getNewBadgeIfIsNew(strategy.is_new, translate)}
        >
          <AutomaticTransactionSignal
            strategy={strategy}
            ticker={ticker}
            market={filterMarket}
            stockName={stockName}
            shortName={shortName}
          />
        </StockPageSection>
      ))}
    </React.Fragment>
  );
};

TransactionSignalSections.propTypes = {
  strategies: PropTypes.array,
  ticker: PropTypes.string,
  market: PropTypes.string,
  stockName: PropTypes.string,
  shortName: PropTypes.string,
  filterMarket: PropTypes.string
};

export default withTranslations(TransactionSignalSections);
